import { jsxs, jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { q as queue, a as EGDSFigure, b as EGDSImage } from '../image-link/index-chunk.esm.js';

class EGDSQueuedImage extends React.Component {
    imgRef;
    static displayName = 'EGDSQueuedImage';
    static defaultProps = {
        useBackgroundImage: false,
    };
    constructor(props) {
        super(props);
        this.state = {
            src: undefined,
        };
        this.setImgRef = this.setImgRef.bind(this);
    }
    UNSAFE_componentWillMount() {
        const { serverRender, src } = this.props;
        if (serverRender && src) {
            this.setState({ src });
        }
    }
    componentDidMount() {
        const { state } = this;
        const { props } = this;
        const srcFromState = state.src;
        const srcFromProps = props.src;
        if (!srcFromState) {
            this.loadImage(srcFromProps);
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { src } = this.props;
        if (src !== nextProps.src) {
            this.loadImage(nextProps.src);
        }
    }
    componentDidUpdate(prevProps) {
        const { src } = this.props;
        if (src !== prevProps.src) {
            this.loadImage(src);
        }
    }
    componentWillUnmount() {
        const { src, groupId } = this.props;
        queue.dequeue(src, groupId);
    }
    setImgRef(r) {
        this.imgRef = r;
    }
    loadImage(src) {
        const { groupId } = this.props;
        if (src && src.length > 0) {
            queue.enqueue({
                callback: (err) => this.imageDidLoad(err),
                imageUrl: src,
                imgRef: this.imgRef,
                source: groupId,
            });
        }
    }
    imageDidLoad(error) {
        const { queuedImageFallbackCallback, src } = this.props;
        if (error && queuedImageFallbackCallback) {
            queuedImageFallbackCallback(this);
        }
        else {
            this.setState({ src });
        }
    }
    render() {
        const { alt, children, className, useBackgroundImage, ratio, 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        src: propSrc, // This is destructured so it's not passed down as additionalProps
        serverRender, serverRenderCallback, loaded, ...restOfProps } = this.props;
        const { src } = this.state;
        const additionalProps = { alt, 'data-loaded': Boolean(src), ...restOfProps };
        if (additionalProps.groupId) {
            delete additionalProps.groupId;
        }
        if (useBackgroundImage) {
            let style = src ? { backgroundImage: `url(${src})` } : {};
            if (serverRender && serverRenderCallback) {
                style = serverRenderCallback(style);
            }
            return (jsxs(EGDSFigure, { className: className, style: style, ratio: ratio, additionalProps: additionalProps, children: [children, !src && loaded && jsx(EGDSImage, { placeholderImage: true })] }));
        }
        return (jsx(EGDSImage, { imgRef: this.setImgRef, className: className, src: src, alt: alt, additionalProps: additionalProps, placeholderImage: !src }));
    }
}

export { EGDSQueuedImage as E };
//# sourceMappingURL=index-chunk.esm.js.map
